import axios from 'axios';

export default function() {
  const variants = document.querySelectorAll('[data-variant-id]');
  if (variants.length === 0) return;

  const lightbeans = document.querySelector('[data-lightbeans]');
  const lightbeansTextureBtn = document.querySelector('[data-lightbeans-texture]');
  const formProduct = document.getElementById("form-product");
  const productPurshasableInput = formProduct?.querySelector('[name="purchasables[0][id]"]');
  const productPurshasableQtyInput = formProduct?.querySelector('[name="purchasables[0][qty]"]');
  const productSuccessMessage = formProduct?.querySelector("input[name='successMessage']");
  const productButtonSubmit = formProduct?.querySelector("button[type='submit']");
  const formSampleProduct = document.getElementById("form-product-sample");
  const samplePurshasableInput = formSampleProduct?.querySelector('[name="purchasables[0][id]"]');
  const sampleProductSuccessMessage = formSampleProduct?.querySelector("input[name='successMessage']");
  const selectedColorDiv = document.querySelector('[data-selected-color]');
  const selectedColorQuickShipDiv = document.querySelector('[data-selected-color-quick-ship]');
  const swatchList = document.querySelector('.swatch-list');
  const viewMoreButton = document.querySelector('.swatch-list-view-more');

  variants.forEach(variant => {
    variant.addEventListener('click', () => {
      variants.forEach(v2 => {
        v2.classList.remove('active');
      });
      variant.classList.add('active');
      lightbeans.setAttribute('src', lightbeans.dataset.srcPrefix + variant.dataset.variantLightbeansSku + lightbeans.dataset.srcSuffix + "&fallbackImage=" + variant.dataset.fallbackImage);

      if (lightbeansTextureBtn) {
        lightbeansTextureBtn.dataset.product = lightbeansTextureBtn.dataset.productPrefix + variant.dataset.variantLightbeansSku;
      }

      selectedColorDiv.innerText = variant.dataset.variantTitle + " " + variant.dataset.variantColor;

      if (variant.dataset.variantQuickShip === '1') {
        selectedColorQuickShipDiv.classList.remove('hidden');
      } else {
        selectedColorQuickShipDiv.classList.add('hidden');
      }

      if (formProduct) {
        productPurshasableInput.value = variant.dataset.variantId;
        updateSuccessMessage(variant.dataset.variantSuccessMessage, productSuccessMessage, productPurshasableQtyInput.value);

        const stock = parseInt(variant.dataset.variantStock);
        productPurshasableQtyInput.setAttribute('max', variant.dataset.variantStock);
        if (productPurshasableQtyInput.value > stock) {
          productPurshasableQtyInput.value = stock;
        }
        if (stock === 0) {
          productButtonSubmit.setAttribute("disabled", "disabled");
          productButtonSubmit.setAttribute("title", productButtonSubmit.dataset.noStock);
        } else {
          productButtonSubmit.removeAttribute("disabled");
          productButtonSubmit.removeAttribute("title");
        }
      }

      if (formSampleProduct) {
        samplePurshasableInput.value = variant.dataset.variantSampleId;
        updateSuccessMessage(variant.dataset.variantSampleSuccessMessage, sampleProductSuccessMessage, 1);
      }
    });
  });

  if (lightbeansTextureBtn) {
    lightbeansTextureBtn.addEventListener("click", () => {
      const event = new CustomEvent("__lb_show_popup_", {detail:{
          texture: lightbeansTextureBtn.dataset.product,
          lang: lightbeansTextureBtn.dataset.lang,
          bkgcolor: "#2B2B2B",
        }});
      document.body.dispatchEvent(event);
    });
  }

  if (productPurshasableQtyInput) {
    productPurshasableQtyInput.addEventListener("change", () => {
      updateSuccessMessage(productSuccessMessage.dataset.value, productSuccessMessage, productPurshasableQtyInput.value);
      updateSuccessMessage(sampleProductSuccessMessage.dataset.value, sampleProductSuccessMessage, 1);
    });
  }

  const updateSuccessMessage = (successMessage, inputSuccessMessage, quantity) => {
    axios({
      url: '/actions/website/product/hash-data?value=' + encodeURIComponent(successMessage.replace("{quantity}", quantity)),
      method: 'get',
    }).then((result) => {
      console.log(result.data);
      inputSuccessMessage.value = result.data;
      inputSuccessMessage.dataset.value = successMessage;
    }).catch(() => {});
  };

  document.querySelector('[data-variant-id].active')?.click();

  if (viewMoreButton) {
    viewMoreButton.addEventListener('click', () => {
      swatchList.classList.remove('max-h-[125px]');
      viewMoreButton.style.display = 'none';
    });
  }
}
